const updateItems = [
  { time: '07-31 14:30', title: '《时空穿梭者：终局》4K超清版正式上线', type: '上新' },
  { time: '07-31 12:15', title: '暑期档专题"大片扎堆谁能称王"已更新第三期', type: '专题' },
  { time: '07-31 09:00', title: '平台播放引擎升级至v4.2，首帧加载速度提升30%', type: '系统' },
  { time: '07-30 22:40', title: '《长安夜未央》第28集同步卫视更新', type: '更新' },
  { time: '07-30 18:20', title: '韩剧专区新增五部9分+口碑剧集', type: '上新' },
  { time: '07-30 15:00', title: '纪录片《深蓝星球》全集上线，IMAX级画质', type: '上新' },
  { time: '07-30 10:45', title: '移动端播放器升级：新增手势调节亮度和音量', type: '系统' },
  { time: '07-29 20:00', title: '经典港片修复计划启动，《英雄本色》4K修复版率先上线', type: '专题' },
  { time: '07-29 16:30', title: '《极地求生：零下72小时》中文字幕精校版更新', type: '更新' },
];

function getTypeStyle(type: string) {
  switch (type) {
    case '上新':
      return 'bg-green-100 text-green-700';
    case '专题':
      return 'bg-accent-100 text-accent-800';
    case '系统':
      return 'bg-secondary-100 text-secondary-700';
    case '更新':
      return 'bg-primary-100 text-primary-700';
    default:
      return 'bg-background-200 text-foreground-600';
  }
}

export default function SectionUpdates() {
  return (
    <section id="updates" className="bg-background-100 py-16 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-green-100 text-green-700 whitespace-nowrap mb-3">
            实时动态
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            最新更新
          </h2>
          <p className="text-foreground-600 text-sm mt-2">站内影片资源与系统功能的最新变化，实时同步</p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-5 top-2 bottom-2 w-px bg-background-300"></div>
          <div className="space-y-4">
            {updateItems.map((item, index) => (
              <div key={index} className="relative flex items-start gap-4 md:gap-5 pl-10 md:pl-12">
                <div className="absolute left-2.5 md:left-3.5 top-1.5 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100 flex-shrink-0"></div>
                <div className="flex-1 min-w-0 bg-background-50 rounded-lg p-4 border border-background-200/70">
                  <div className="flex flex-wrap items-center gap-2 mb-1.5">
                    <span className={`px-2 py-0.5 text-[10px] font-medium rounded whitespace-nowrap ${getTypeStyle(item.type)}`}>
                      {item.type}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                  </div>
                  <p className="text-foreground-800 text-sm leading-relaxed">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}